import { Button, Stack } from '@mui/material'

export type FormbuilderGroupFooterProps = {
  addButtonText: string
  canAdd: boolean
  canRemove: boolean
  onAdd: () => void
  onRemove: () => void
  removeButtonText: string
}

export function FormbuilderGroupFooter({
  addButtonText,
  canAdd,
  canRemove,
  onAdd,
  onRemove,
  removeButtonText,
}: FormbuilderGroupFooterProps) {
  return (
    <Stack direction="row" sx={{ gap: 2, mt: 1 }}>
      {/* Botão para adicionar nova entrada */}
      <Button
        size="small"
        onClick={onAdd}
        disabled={!canAdd}
        variant="outlined"
        sx={{ minWidth: 120 }}
      >
        {addButtonText}
      </Button>

      {/* Botão para remover última entrada */}
      <Button
        size="small"
        color="error"
        onClick={onRemove}
        disabled={!canRemove}
        variant="outlined"
        sx={{ minWidth: 120 }}
      >
        {removeButtonText}
      </Button>
    </Stack>
  )
}
